import React, { useState } from 'react';

import { Row, Col, Button } from 'react-bootstrap';
import Fade from 'react-bootstrap/Fade';
import ResourcesLeft from '../Resources/Resources_Left'

import Breadcrumb from '../../Breadcrumb/Main'
import Header from '../../headerone/Main'
import { Link } from 'react-router-dom'


function Festivals() {

    const [ChemistryOpen, setChemistry] = useState(true);
    const [ComputerOpen, setComputer] = useState(false);
    const [MechanicsOpen, setMechanics] = useState(false);
    const [PhysicsOpen, setPhysics] = useState(false);
    const [WorkshopOpen, setWorkshop] = useState(false)


    const handleClick = (event) => {
        setChemistry(false);
        setComputer(false);
        setMechanics(false);
        setPhysics(false);
        setWorkshop(false);
        event(true);
    }



    const ChemistryImg = [

        { img: "https://files.iittp.ac.in/images/demo/iit/Labs/C1.jpg" },
        { img: "https://files.iittp.ac.in/images/demo/iit/Labs/C2.jpg" },
        { img: "https://files.iittp.ac.in/images/demo/iit/Labs/C3.jpg" }

    ]




    const ComputerImg = [

        { img: "https://files.iittp.ac.in/images/demo/iit/Labs/comp1.JPG" },
        { img: "https://files.iittp.ac.in/images/demo/iit/Labs/comp2.jpg" },
        { img: "https://files.iittp.ac.in/images/demo/iit/Labs/comp3.JPG" }


    ]

    const MechanicsImg = [

        { img: "https://files.iittp.ac.in/images/demo/iit/Labs/mech1.jpg" },
        { img: "https://files.iittp.ac.in/images/demo/iit/Labs/mech2.jpg" },
        { img: "https://files.iittp.ac.in/images/demo/iit/Labs/mech3.jpg" },
        { img: "https://files.iittp.ac.in/images/demo/iit/Labs/mech4.jpg" },
        { img: "https://files.iittp.ac.in/images/demo/iit/Labs/mech5.jpg" }

    ]

    const MechanicsMoolakonnamImg = [

        { img: "https://files.iittp.ac.in/images/demo/iit/Events/Trekking/moolakonnam/2.jpg" },
        { img: "https://files.iittp.ac.in/images/demo/iit/Events/Trekking/moolakonnam/5.jpg" }
    ]

    const PhysicsImg = [

        { img: "https://files.iittp.ac.in/images/demo/iit/Labs/p1.jpg" },
        { img: "https://files.iittp.ac.in/images/demo/iit/Labs/p2.jpg" },
        { img: "https://files.iittp.ac.in/images/demo/iit/Labs/p3.jpg" },
        { img: "https://files.iittp.ac.in/images/demo/iit/Labs/p4.JPG" }

    ]
    const WorkshopImg = [

        { img: "https://files.iittp.ac.in/images/demo/iit/Labs/Workshop1.jpg" },
        { img: "https://files.iittp.ac.in/images/demo/iit/Labs/Workshop2.jpg" },
        { img: "https://files.iittp.ac.in/images/demo/iit/Labs/Workshop3.jpg" },
        { img: "https://files.iittp.ac.in/images/demo/iit/Labs/Workshop4.jpg" }

    ]


    return (

        <>
            <Header />
            <Breadcrumb title='Home' subtitle="CLUBS" />
            <section className="team-area fix p-relative pt-120 pb-80">
                <div className="container">
                    <div className="lower-content">
                        <Row>
                            <div className="c-heading">
                                <h3>LABS @ TEMPORARY CAMPUS</h3> <br />
                            </div>

                            <Col md={3} className='c-left custom-padding-color mb-5'>
                                <ResourcesLeft activeIndex={0} />
                            </Col>

                            <Col md={9} className='c-righ'>

                                <Row className='mb-5 text-center'>

                                    <Col xs={6} sm={4} md={2} lg={2} className="mb-3">
                                        <Button className='btn-sm c-button'
                                            onClick={() => handleClick(setChemistry)}
                                            aria-controls="c-Chemistry"
                                            aria-expanded={ChemistryOpen}>
                                            Chemistry
                                        </Button>
                                    </Col>

                                    <Col xs={6} sm={4} md={2} lg={2} className="mb-3">
                                        <Button className='btn-sm c-button '
                                            onClick={() => handleClick(setComputer)}
                                            aria-controls="c-Computer"
                                            aria-expanded={ComputerOpen}>
                                            Computer
                                        </Button>
                                    </Col>

                                    <Col xs={6} sm={4} md={2} lg={2} className="mb-3">
                                        <Button className='btn-sm c-button '
                                            onClick={() => handleClick(setMechanics)}
                                            aria-controls="c-Mechanics"
                                            aria-expanded={MechanicsOpen}>
                                            Applied Mechanics
                                        </Button>
                                    </Col>


                                    <Col xs={6} sm={4} md={2} lg={2} className="mb-3">
                                        <Button className='btn-sm c-button '
                                            onClick={() => handleClick(setPhysics)}
                                            aria-controls="c-Physics"
                                            aria-expanded={PhysicsOpen}>
                                            Physics
                                        </Button>
                                    </Col>


                                    <Col xs={6} sm={4} md={2} lg={2} className="mb-3">
                                        <Button className='btn-sm c-button '
                                            onClick={() => handleClick(setWorkshop)}
                                            aria-controls="c-Workshop"
                                            aria-expanded={WorkshopOpen}>
                                            Workshop
                                        </Button>
                                    </Col>


                                </Row>


                                {/*Chemistry */}
                                <div>
                                    {ChemistryOpen && <Fade in={ChemistryOpen}>
                                        <div className='c-lineheight2dot5'>

                                            <h4>Chemistry Lab </h4>

                                            <p>The undergraduate chemistry laboratory was established in January 2016. It is well ventilated and has new and modern state-of-the-art equipment. A total of 10 experiments that address societal issues are performed at the chemistry laboratory. These experiments were designed to make practical sessions interesting for the undergraduate engineering students.
                                                The following are some of these experiments:
                                            </p>
                                            <ul className='ms-3 c-lineheight2dot5 iarrow' >
                                                <li><i className="fal fa-arrow-alt-circle-right me-3 c-link" />   1. Water quality : Hardness of samples drawn from the neighbourhood </li>
                                                <li><i className="fal fa-arrow-alt-circle-right me-3 c-link" />2. Pharmacy : Aspirin (making a medicine)</li>
                                                <li><i className="fal fa-arrow-alt-circle-right me-3 c-link" /> 3. Natural product : Tea leaves (extraction of caffeine from different brands of tea available in the market)</li>
                                                <li><i className="fal fa-arrow-alt-circle-right me-3 c-link" />4. Food world : Citrus fruits (acidity of different fruits) </li>
                                                <li><i className="fal fa-arrow-alt-circle-right me-3 c-link" /> 5. Material world : Brass (copper content) </li>
                                            </ul>

                                            <h3 className='c-headline mt-5 mb-3'>Our Gallary</h3>
                                            <div className="grid col3 row wow fadeInUp  animated" data-animation="fadeInUp" data-delay=".4s" >
                                                {ChemistryImg.map((item, Index) => (
                                                    <div className="financial col-4 mt-3" key={Index}>
                                                        <figure className="gallery-image">
                                                            <img src={item.img} alt="img" className="img" />
                                                        </figure>
                                                    </div>
                                                ))}
                                            </div>

                                            <h3 className='c-headline mt-5 mb-3'>Equipment at the Chemistry Laboratory </h3>
                                            <ul className='ms-3 c-lineheight2dot5 iarrow' >
                                                <li><i className="fal fa-arrow-alt-circle-right me-3 c-link" /> 1. Laboratory fume hoods </li>
                                                <li><i className="fal fa-arrow-alt-circle-right me-3 c-link" /> 2. Conductivity meter </li>
                                                <li><i className="fal fa-arrow-alt-circle-right me-3 c-link" /> 3. pH meter </li>
                                                <li><i className="fal fa-arrow-alt-circle-right me-3 c-link" /> 4. Magnetic stirrer </li>
                                                <li><i className="fal fa-arrow-alt-circle-right me-3 c-link" /> 5. Preparative weighing balance </li>
                                                <li><i className="fal fa-arrow-alt-circle-right me-3 c-link" /> 6. Analytical weighing balance </li>
                                                <li><i className="fal fa-arrow-alt-circle-right me-3 c-link" /> 7. Digital colorimeter </li>
                                                <li><i className="fal fa-arrow-alt-circle-right me-3 c-link" /> 8. Hot plate </li>
                                                <li><i className="fal fa-arrow-alt-circle-right me-3 c-link" /> 9. Melting point apparatus </li>
                                                <li><i className="fal fa-arrow-alt-circle-right me-3 c-link" /> 10. Hot water bath </li>
                                                <li><i className="fal fa-arrow-alt-circle-right me-3 c-link" /> 11. Ice - akers </li>
                                                <li><i className="fal fa-arrow-alt-circle-right me-3 c-link" /> 12. Vacuum pump </li>
                                                <li><i className="fal fa-arrow-alt-circle-right me-3 c-link" /> 13. Distilled water system </li>
                                                <li><i className="fal fa-arrow-alt-circle-right me-3 c-link" /> 14. Hot air oven </li>
                                                <li><i className="fal fa-arrow-alt-circle-right me-3 c-link" /> 15. Rotary evaporator </li>
                                                <li><i className="fal fa-arrow-alt-circle-right me-3 c-link" /> 16. Chiller for circulation of cold water </li>
                                            </ul>
                                        </div>

                                    </Fade>
                                    }
                                </div>


                                {/*Computer*/}

                                <div>
                                    {ComputerOpen && <Fade in={ComputerOpen}>
                                        <div className='c-lineheight2dot5'>
                                            <h4>Computer Lab  </h4>

                                            <p>A computer laboratory has been set up, so that the students can perform software-based experiments and programming. The laboratory is equipped with 60 state-of-the-art all-in-one desktop systems, two short view projectors and an audio system. The latest systems and software, including Autodesk packages, were installed in the labs, library and faculty rooms.</p>

                                            <h3 className='c-headline mt-5 mb-3'>Our Gallary</h3>
                                            <div className="grid col3 row wow fadeInUp  animated" data-animation="fadeInUp" data-delay=".4s" >
                                                {ComputerImg.map((item, Index) => (
                                                    <div className="financial col-4 mt-3" key={Index}>
                                                        <figure className="gallery-image">
                                                            <img src={item.img} alt="img" className="img" />
                                                        </figure>
                                                    </div>
                                                ))}
                                            </div>



                                        </div>
                                    </Fade>
                                    }
                                </div>



                                {/*Mechanics */}
                                <div>
                                    {MechanicsOpen && <Fade in={MechanicsOpen}>
                                        <div className='c-lineheight2dot5'>

                                            <h4>Applied Mechanics Lab </h4>

                                            <p>Applied mechanics laboratory has been set up for students to perform experiments related to basic principles of solid mechanics and fluid mechanics. Experimental setups related to fluid mechanics includes Osborne Reynolds experiment, fluid property measurement, stability of floating body, momentum conservation through impact of liquid jet on surface, Bernoulli’s principle verification, methods of flow measurements, frictional losses in pipe, free and forced vortex generation and flow visualization around objects are available. Solid mechanics experiments include universal testing machine for tensile tests, hardness testing machine, torsion measurement, stresses in thick and thin cylinders, strain measurement using strain gauges, bending of beams, photo elasticity measurements and impact tester. </p>

                                            <h3 className='c-headline mt-5 mb-3'>Our Gallary</h3>
                                            <div className="grid col3 row wow fadeInUp  animated" data-animation="fadeInUp" data-delay=".4s" >
                                                {MechanicsImg.map((item, Index) => (
                                                    <div className="financial col-4 mt-3" key={Index}>
                                                        <figure className="gallery-image">
                                                            <img src={item.img} alt="img" className="img" />
                                                        </figure>
                                                    </div>
                                                ))}
                                            </div>


                                        </div>
                                    </Fade>
                                    }
                                </div>


                                {/*Physics */}
                                <div>
                                    {PhysicsOpen && <Fade in={PhysicsOpen}>
                                        <div className='c-lineheight2dot5'>
                                            <h4>Physics Lab  </h4>

                                            <p>The initial focus was on setting up the laboratories and getting the foundation courses in physics formulated for the first batch of students joining the institute, in August 2015. A set of about 10 experiments was planned. Some of the experiments were adopted from the mentoring institute (IIT Madras), and the necessary equipment was procured. The apparatus was fabricated at IIT Madras in record time, to be used in the first semester at the new institute. </p>

                                            <h3 className='c-headline mt-5 mb-3'>Our Gallary</h3>
                                            <div className="grid col3 row wow fadeInUp  animated" data-animation="fadeInUp" data-delay=".4s" >
                                                {PhysicsImg.map((item, Index) => (
                                                    <div className="financial col-4 mt-3" key={Index}>
                                                        <figure className="gallery-image">
                                                            <img src={item.img} alt="img" className="img" />
                                                        </figure>
                                                    </div>
                                                ))}
                                            </div>

                                            <h3 className='c-headline mt-5 mb-3'>Equipment at the Physics Laboratory  </h3>
                                            <ul>
                                                <li><i className="fal fa-arrow-alt-circle-right me-3 c-link" /> 1. Compound pendulum with accessories (five sets)</li>
                                                <li><i className="fal fa-arrow-alt-circle-right me-3 c-link" /> 2. Ultrasonic interferometer (five sets)</li>
                                                <li><i className="fal fa-arrow-alt-circle-right me-3 c-link" /> 3. Experimental setup for obtaining Stefan’s constant (five sets)</li>
                                                <li><i className="fal fa-arrow-alt-circle-right me-3 c-link" /> 4. Newton rings experiment (six sets)</li>
                                                <li><i className="fal fa-arrow-alt-circle-right me-3 c-link" /> 5. Spectrometer with diffraction grating (six sets)</li>
                                                <li><i className="fal fa-arrow-alt-circle-right me-3 c-link" /> 6. Mapping of equipotential lines with electrode configuration (five sets)</li>
                                                <li><i className="fal fa-arrow-alt-circle-right me-3 c-link" /> 7. Digital oscilloscope (six sets)</li>
                                                <li><i className="fal fa-arrow-alt-circle-right me-3 c-link" /> 8. Hall effect apparatus with accessories (five sets)</li>
                                                <li><i className="fal fa-arrow-alt-circle-right me-3 c-link" /> 9. Planck’s constant using LEDs (five sets)</li>
                                                <li><i className="fal fa-arrow-alt-circle-right me-3 c-link" /> 10. Simulation lab using MATLAB (10 sets)</li>
                                                <li><i className="fal fa-arrow-alt-circle-right me-3 c-link" /> 11. Forbe’s method apparatus</li>
                                                <li><i className="fal fa-arrow-alt-circle-right me-3 c-link" /> 12. Linear air track with digital timer (one)</li>
                                                <li><i className="fal fa-arrow-alt-circle-right me-3 c-link" /> 13. Timing car + plane ramp + accessories + inclined plane accessory + curved ramp (one)</li>
                                                <li><i className="fal fa-arrow-alt-circle-right me-3 c-link" /> 14. Four-probe method of measurement of conductivity (four sets)</li>
                                                <li><i className="fal fa-arrow-alt-circle-right me-3 c-link" /> 15. Strain gauge for stress/strain measurements (four sets)</li>
                                            </ul>


                                        </div>
                                    </Fade>
                                    }
                                </div>



                                {/*Workshop */}
                                <div>
                                    {WorkshopOpen && <Fade in={WorkshopOpen}>
                                        <div className='c-lineheight2'>
                                            <h4>Workshop </h4>
                                            <p>In the first semester, workshop training sessions for all the branches of engineering were held in the workshop facilities in the premises of Sri Venkateswara University, Tirupati. The second semester workshop sessions were conducted at IIT Tirupati by procuring and installing the necessary equipment, including pneumatics and hydraulics training kits, a plastic injection moulding machine and FRP fabrication facilities. A basic electrical and electronics lab, and an instrumentation and communications lab, were set up for workshop practice.  </p>


                                            <h3 className='c-headline mt-5 mb-3'>Our Gallary </h3>
                                            <div className="grid col3 row wow fadeInUp  animated text-center mt-5" data-animation="fadeInUp" data-delay=".4s" >
                                                {WorkshopImg.map((item, Index) => (
                                                    <div className="financial col-4 mt-3" key={Index}>
                                                        <figure className="gallery-image">
                                                            <img src={item.img} alt="img" className="img" />
                                                        </figure>
                                                    </div>
                                                ))}
                                            </div>
                                      

                                        <Row className='mt-5'>

                                            <Col md={6} className='c-left custom-padding-color mb-3'>
                                                    <div className="border border-dark p-3">
                                                    <h3 className='c-headline mt-5 mb-3'>Workshop 1 Module (WS1010)  </h3>
                                                    <ul className='ms-3 c-lineheight2dot5 iarrow ' >
                                                        <li><i className="fal fa-arrow-alt-circle-right me-3 c-link" />  Machining Process </li>
                                                        <li><i className="fal fa-arrow-alt-circle-right me-3 c-link" />Power Tools </li>
                                                        <li><i className="fal fa-arrow-alt-circle-right me-3 c-link" />Welding </li>
                                                    </ul>
                                                </div>
                                            </Col>
                                            <Col md={6} className='c-right'>
                                                    <div className="border border-dark p-3 ">
                                                    <h3 className='c-headline mt-5 mb-3'>Workshop 2 Module (WS1020)   </h3>
                                                    <ul className='ms-3 c-lineheight2dot5 iarrow ' >
                                                        <li><i className="fal fa-arrow-alt-circle-right me-3 c-link" /> Basic Electrical</li>
                                                        <li><i className="fal fa-arrow-alt-circle-right me-3 c-link" />Basic Electronic </li>
                                                        <li><i className="fal fa-arrow-alt-circle-right me-3 c-link" />Instrumentation and Communication </li>
                                                        <li><i className="fal fa-arrow-alt-circle-right me-3 c-link" />Pneumatic and Hydraulic</li>
                                                        <li><i className="fal fa-arrow-alt-circle-right me-3 c-link" />Fiber Reinforced Plastic</li>
                                                    </ul>
                                                </div>
                                            </Col>
                                        </Row>
                                        </div>
                                    </Fade>
                                    }
                                </div>

                            </Col>
                        </Row>
                    </div>
                </div>
            </section>
        </>
    );
}

export default Festivals;
